/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, Chip, Grid, TextField } from '@mui/material';
import BorderButton from '@app/components/atoms/BorderButton';
import RoundedButton from '@app/components/atoms/RoundedButton';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import Autocomplete from '@app/components/molecules/Autocomplete';
import { colors } from '@app/config/colors';
import Spacer from '@app/components/atoms/Spacer';
import MutationsStatus from '@app/components/molecules/MutationsStatus';
import { useMutation } from '@apollo/client';
import { INVITE_REVIEWER } from '@app/apollo/mutations';
import { useTranslation } from '@app/config/i18n';

const AssignReviewerForm = ({ opportunity, setShowAssignReviewerForm, refetch, application }) => {
  const { t } = useTranslation(['common', 'wizard', 'applications']);
  const [reviewerInfo, setReviewerInfo] = React.useState([]);

  const { committee_members } = opportunity;

  // const programCommitteeMembers = committee_members.filter(
  //   (item) => item.roles.map((role) => role.committee_group).indexOf('Program Committee') >= 0
  // );
  const programCommitteeMembers = committee_members;

  const handleOnChangeProgramCommitteeMember = (event, members) => {
    const formattedReviewers = members.map((member) => ({
      name: member.name,
      email: member.email,
    }));
    setReviewerInfo(formattedReviewers);
  };

  const handleSuccessInvitation = () => {
    setTimeout(() => {
      setShowAssignReviewerForm(false);
      refetch();
    }, 500);
  };

  const [
    inviteReviewerMutation,
    { loading: mutationLoading, error: mutationError, data: mutationData },
  ] = useMutation(INVITE_REVIEWER, {
    onCompleted: handleSuccessInvitation,
  });

  const handleInviteReviewer = () => {
    inviteReviewerMutation({
      variables: {
        // input: {
        //   ...reviewerInfo,
        //   opportunityId: opportunity.id,
        //   applications: [application.id],
        // },
        input: reviewerInfo.map((reviewer) => ({
          name: reviewer.name,
          email: reviewer.email,
          opportunityId: opportunity.id,
          applications: [application.id],
        })),
      },
    });
  };

  return (
    <>
      <MutationsStatus loading={mutationLoading} error={mutationError} success={mutationData} />
      <Grid container>
        <Grid item lg={6}>
          <Grid container>
            <Grid item lg={12}>
              <Spacer height="1rem" />
              <Autocomplete
                multiple
                options={programCommitteeMembers}
                getOptionLabel={(option) => option.name}
                isOptionEqualToValue={(option, value) => option.email === value.email}
                getOptionDisabled={(option) =>
                  reviewerInfo.some((r) => r.email === option.email)
                }
                id="committee_members"
                name="committee_members"
                label={t('applications:select-committee')}
                value={reviewerInfo}
                onChange={handleOnChangeProgramCommitteeMember}
                sx={{ marginLeft: '1rem', width: '90%' }}
                renderTags={(selected, getTagProps) =>
                  selected.map((option, index) => (
                    <Chip
                      key={option.email}
                      label={option.name}
                      avatar={<Avatar>{option.name.charAt(0)}</Avatar>}
                      sx={{
                        backgroundColor: '#E3F2FD',
                        color: '#0D47A1',
                        margin: '2px',
                        fontWeight: 500,
                      }}
                      {...getTagProps({ index })}
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label={t('applications:select-committee')}
                    placeholder={t('common:select-reviewers')}
                  />
                )}
              />
            </Grid>
            <Spacer height="10rem" />
          </Grid>
          <Grid container justifyContent="flex-end">
            <Grid item lg={2}>
              <BorderButton
                variant="text"
                color="primary"
                size="small"
                onClick={() => setShowAssignReviewerForm(false)}
              >
                {t('common:cancel')}
              </BorderButton>
            </Grid>
            <Grid item lg={4}>
              <RoundedButton
                variant="contained"
                endIcon={<CheckRoundedIcon />}
                sx={{ backgroundColor: colors.primaryColor[800] }}
                size="small"
                fullWidth
                onClick={handleInviteReviewer}
                disabled={reviewerInfo.length === 0 || mutationLoading}
              >
                {t('common:send_invites')}
              </RoundedButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

AssignReviewerForm.propTypes = {
  opportunity: PropTypes.object.isRequired,
  setShowAssignReviewerForm: PropTypes.func.isRequired,
  refetch: PropTypes.func.isRequired,
  application: PropTypes.object.isRequired,
};

export default AssignReviewerForm;
